// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n2-1";
export var stateContainer = "_n2-0";